import {HStack, Icon, Text, ThemeIconKey, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {Payment} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface PaymentDirectionProps extends RequiredTestIdProps {
  direction: Payment['direction'];
}

export function PaymentDirection(props: PaymentDirectionProps) {
  const icon = match<Payment['direction'], ThemeIconKey>(props.direction)
    .with('incoming', () => 'navigation/arrow_forward')
    .with('outgoing', () => 'navigation/arrow_back')
    .exhaustive();

  const label = match(props.direction)
    .with('incoming', () => i18n.t('entity.prescription.labels.incoming'))
    .with('outgoing', () => i18n.t('entity.prescription.labels.outgoing'))
    .exhaustive();

  return (
    <VStack spacing={1}>
      <Text size="xSmall" color="secondary">
        {i18n.t('general.labels.direction')}
      </Text>
      <HStack align="center" spacing={1}>
        <Icon value={icon} size={3} />
        <Text data-testid={suffixTestId('paymentDirection', props)}>{label}</Text>
      </HStack>
    </VStack>
  );
}
